// extracted by mini-css-extract-plugin
module.exports = {"editSysTimeBox":"editSysTimeBox--lWO5o","addStar":"addStar--nndOb","tip":"tip--kgjSP"};